import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';

import { ProjectBloc } from '@connect-services/client/blocs/project.bloc';
import { ProjectDepositSectionComponent } from '@connect-services/client/components/project-settings/project-deposits-settings/project-deposit-section/project-deposit-section.component';
import { SectionHeaderComponent } from '@connect-services/client/components/section-header/section-header.component';
import { ProjectDepositsSettingsService } from '@connect-services/client/services/project-deposits-settings.service';
import { ExpansionPanelComponent } from '@connect-services/src/lib/components/expansion-panel/expansion-panel.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ExpansionPanelComponent,
        LoadingComponent,
        ProjectDepositSectionComponent,
        RessourcesModule,
        SectionHeaderComponent,
    ],
    providers: [ProjectDepositsSettingsService],
    selector: 'app-project-deposits-settings',
    styleUrl: '../project-layers-settings/project-layers-settings.component.scss',
    templateUrl: './project-deposits-settings.component.html',
})
export class ProjectDepositsSettingsComponent {
    protected readonly projectDepositsSettingsService = inject(ProjectDepositsSettingsService);

    private readonly projectBloc = inject(ProjectBloc);

    public constructor() {
        effect(async () => {
            if (!this.projectBloc.value()) {
                return;
            }

            await this.projectDepositsSettingsService.loadDeposits();
        });
    }
}
